import { useQuery, useQueryClient } from "@tanstack/vue-query";
import { notificationsService } from "@/utils/api/notificationsService";

export function useNotifications() {
  const queryClient = useQueryClient();
  const { data: notifications, isFetched: isNotification } = useQuery({
    queryKey: ["notifications"],
    queryFn: () =>
      notificationsService.getNotifications({
        per_page: 6,
        order_by: "read_at",
      }),
  });

  onMounted(() => {
    const intervalId = setInterval(
      () => {
        queryClient.invalidateQueries({ queryKey: ["notifications"] });
      },
      10 * 60000, //minutes
    );

    onUnmounted(() => {
      clearInterval(intervalId);
    });
  });

  return { notifications, isNotification };
}
